import { createReducer } from 'redux-act';
import * as actions from '#app/actions/simpleTransfer';

interface SimpleTransferState {
  modalVisible: boolean;
  form: Record<string, unknown>;
}

const initialState: SimpleTransferState = {
  modalVisible: false,
  form: {},
};

const setSimpleTransferModalVisible = (
  state: SimpleTransferState,
  bool: boolean
): SimpleTransferState => ({
  ...state,
  modalVisible: bool,
});

const closeSimpleTransferForm = (state: SimpleTransferState): SimpleTransferState => ({
  ...state,
  form: {},
  modalVisible: false,
});

const setSimpleTransferForm = (
  state: SimpleTransferState,
  form: Record<string, unknown>
): SimpleTransferState => ({
  ...state,
  form: form,
  modalVisible: true,
});

export default createReducer<SimpleTransferState>(
  {
    [actions.setSimpleTransferModalVisible as any]: setSimpleTransferModalVisible,
    [actions.setSimpleTransferForm as any]: setSimpleTransferForm,
    [actions.closeSimpleTransferForm as any]: closeSimpleTransferForm,
  },
  initialState
);
